const ROOT = '/processes';

const routes = {
  list: () => ROOT,
  running: () => `${ROOT}/running`,
  runningItem: (id) => `${ROOT}/running/${id}`,
  runningProcessesByType: (type) => `${ROOT}/running?type=${type}`,
  start: () => `${ROOT}/start`
};

export default routes;
